import { forwardRef, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'

export type SearchInputActions = {
  focus: () => void
  setValue: (value: string) => void
  getValue: () => string
}

const SearchInput = forwardRef<Rest, SearchInputActions>(({ ...rest }, ref) => {
  const inputRef = useRef<HTMLInputElement>()
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus()
    },
    setValue: (value: string) => {
      inputRef.current.value = value
    },
    getValue: () => inputRef.current.value
  }))
  return <StyledSearchInput ref={inputRef} {...rest} />
})

export default SearchInput

const StyledSearchInput = styled.input`
  border: 1px black solid;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  &::placeholder {
    color: ${(props) => props.theme.colors.inputPlaceholder};
  }
  &::-ms-input-placeholder {
    color: ${(props) => props.theme.colors.inputPlaceholder};
  }
  &:focus {
    outline-style: none;
    border: 1px black solid;
  }
  border-radius: ${(props) => props.theme.borderRadius}px;
`
